import { AfterContentInit, AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { CommonModule } from '@angular/common'
import { provideNativeDateAdapter } from '@angular/material/core'
import { MatDialog } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { FormGroup, FormsModule } from '@angular/forms'
import { MatInputModule } from '@angular/material/input'
import { MatFormFieldModule } from '@angular/material/form-field'
import { LineupService } from '../../services/lineup.service'
import { Player } from '../../../../core/models/player.model'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { PlayerCardComponent } from "../../../players/player-card/player-card.component";
import { SearchPlayerDialog } from '../../../../shared/components/search-player/search-player.component'
import { PlayerService } from '../../../../core/services/player.service'
import { ImageService } from '../../../../core/services/images.service'
import { Team } from '../../../../core/models/team.model'
import { MatchService } from 'src/app/core/services/matches.service'
import { SnackbarService } from 'src/app/core/services/snackbar.service'
import { lineups } from 'src/app/core/models/positions.model'
import { Match } from 'src/app/core/models/match.model'
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'lineup-field',
  templateUrl: 'field.component.html',
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    PlayerCardComponent
],
  styleUrls: ['./field.component.css']
})

export class LineupFieldComponent implements AfterViewInit, AfterContentInit{
  @ViewChild('capture') elementToCapture!: ElementRef

  @Input() matchId!: string
  @Input() teamSide: 'for' | 'against' = 'for'
  @Input() editMode: boolean = true

  submitted = -1

  constructor(
    public service: LineupService,
    private playerService: PlayerService,
    private matchService: MatchService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private imageService: ImageService,
    private snackbar: SnackbarService,
  ) {}

  ngAfterViewInit() {
    this.service.screenshotEvent.subscribe(() => this.screenshot())
  }

  ngAfterContentInit(){
    this.service.loadPositions(this.teamSide)
    if(this.matchId) {
      this.matchService.getMatch(this.matchId)
      .subscribe(val=>{
        const lineup = (val.match as Match)[this.teamSide]?.lineup
        this.form.get('formation')?.setValue(lineup?.formation || '4-3-3')
        this.setPositionsFromBackend(lineup?.players || [])
      })
    }
  }

  get positions() {
    return this.service.getPositions(this.teamSide)
  }

  isSubBgRed(team: Team | undefined) {
    return team && team.name.includes('Atlético')
  }

  openDialog(id: number) {
    if (!this.editMode) return 

    const pos = this.positions.find(p => p.starterPositionId === id)
    if (!pos) return

    this.playerService.playerForm.patchValue({
      player: pos.player,
      sub_player: pos.subPlayer
    })

    const dialogRef = this.dialog.open(SearchPlayerDialog, {
      width: '50vw',
      data: 'Lineup'
    })

    dialogRef.afterClosed().subscribe(() => {
      pos.player = undefined
      let player = this.playerService.playerForm.get('player')?.value as Player
      const name = this.playerService.playerForm.get('player_name')?.value
      const sub_player = this.playerService.playerForm.get('sub_player')?.value

      if (!player?._id && !name) return
      if (!player?._id && name) player = new Player({ name })

      pos.player = player
      this.playerService.playerForm.get('player')?.reset()

      if (sub_player) pos.subPlayer = sub_player
      if (name) pos.player!.commonName = name

      this.service.PlayerAdded(id, this.teamSide)
      this.playerService.playerForm.reset()
    })
  }

  screenshot() {
    this.cdr.detectChanges()
    setTimeout(() => {
      const element = this.elementToCapture.nativeElement
      const name = this.form.get('name')?.value || ''
      this.imageService.renderImage(element, 'Atlético Stats - ' + name)
    }, 1000)
  }

  isBlue(player: Player) {
    return !player?.currentTeam || !player?.currentTeam.name.includes('Atlético')
  }

  loadFromBackend() {
    this.matchService.getMatch(this.matchId).subscribe((match: any) => {
      const lineup = match[this.teamSide]?.lineup || {}
      this.form.get('formation')?.setValue(lineup.formation || '4-3-3')
      this.setPositionsFromBackend(lineup.positions)
    })
  }

  saveLineup() {
    this.service.patchMatchLineup(this.teamSide, this.matchId)
      .subscribe(() => this.snackbar.showSnackbar('Alineación guardada.'))
  }

  setPositionsFromBackend(positionsFromDB: any[]) {
    const formation = this.form.get('formation')?.value
    const template = [...lineups[formation as keyof typeof lineups]]

    this.service.positionsMap[this.teamSide] = []

    for (let pos of template) {
      const match = positionsFromDB.find(p => p.starterPositionId === pos.starterPositionId)
      const player = match?.player_id
      this.service.positionsMap[this.teamSide].push({
        ...pos,
        player: player || undefined,
      })
    }
    if (typeof window === 'undefined' || typeof document === 'undefined') return
    setTimeout(() => window.dispatchEvent(new Event('resize')), 0)
  }

  get form() {
    return this.service.getForm(this.teamSide) as FormGroup
  }
}

const Messi = {
  _id: '665c8f7fdcf24b9432df2278',
  age: new Date('1987-06-23T22:00:00.000Z'),
  commonName: 'Messi',
  imgUrl : 'https://assets.sorare.com/playerpicture/daf7c5d4-0cf7-4473-bb00-7beb8c43f78d/picture/squared-2de2a3139116520bc4265fb5356b5f64.png',
  name: 'Lionel Messi',
  nation:'Argentina',
  role: ''
}